module.exports = __webpack_public_path__ + "img/wild1.3c2bff76.png";